import { initAirbrakeClient } from '@ui/lib/airbrake/client'

import { AIRBRAKE_PROJECT } from '@website/lib/airbrake'

initAirbrakeClient(AIRBRAKE_PROJECT)
